import { EventEmitter } from 'events';

export default class ComponentCommunicator extends EventEmitter {
    private static _instance = new ComponentCommunicator()
    static instance(): ComponentCommunicator {
        return this._instance;
    }
}


// WEBPACK FOOTER //
// ./src/components/ComponentCommunicator.tsx